import { StateSchema } from 'app/config/storeConfig/types';

import { ZoneFormDrawerSchema } from '../types';

export const getZoneFormState = (state: StateSchema): ZoneFormDrawerSchema => state.zoneFormDrawer;
